import React from "react";
import { track } from "../../utils/analytics";

/**
 * Signup CTA for anonymous visitors on the public /typing page. Their
 * progress lives only in localStorage, and that is the honest pitch: a free
 * account saves it across devices. Styled after IrabUpsell (which is
 * quota-specific and not reusable here).
 *
 * kind: "list" (slim banner above the lessons) | "results" (after a drill).
 */
export default function TypingUpsell({ context = "typing-public", kind = "list" }) {
  const hasToken = !!localStorage.getItem("token");
  const go = () => {
    track("typing-signup-click", { context, kind });
    window.location.assign(hasToken ? "/" : "/?signup=1");
  };

  return (
    <div
      className={`px-4 rounded-xl shrink-0 flex flex-col sm:flex-row sm:items-center gap-3 ${
        kind === "results" ? "py-3.5 mt-4" : "py-2.5 mb-4"
      }`}
      style={{ background: "var(--tag-violet-bg)", border: "1px solid var(--panel-line)" }}
    >
      <div className="flex-1">
        <p className="text-sm font-semibold text-dt-parchment">
          {kind === "results"
            ? "Nice run — save it before it's gone"
            : "Your progress lives only in this browser"}
        </p>
        <p className="text-xs text-dt-parchment-dim mt-0.5">
          Create a free account to keep your typing progress across devices — and get the full
          Murājaʿa curriculum with it.
        </p>
      </div>
      <button
        onClick={go}
        className="shrink-0 px-4 py-2 rounded-xl bg-dt-gold text-dt-ink hover:brightness-105 text-sm font-semibold transition-[filter]"
      >
        Start your 7-day free trial
      </button>
    </div>
  );
}
